( function () {
	'use strict';
	/* globals angular */

	function pdStatusFactory ( moment, observationService ) {
		var pdList = [];

		function stripHTML ( text ) {
			// replace `<br>` with `\n` and strip all other html
			return String( text ).replace( /<br\s*[\/]?>/gi, '\n' ).replace( /<[^>]+>/gm, '' );
		}

		function insertPdData ( observation ) {
			( observation.masterPrescribedResources || [] ).map( function ( pd ) {
				var pdHolder = angular.copy( pd );

				pdHolder.observation = {
					'id'               : observation.id,
					'name'             : observation.name,
					'startDate'        : moment( observation.startDate ).format( 'MM/DD/YY' ),
					'observee'         : observation.observee.firstName + ' ' + observation.observee.lastName,
					'observer'         : observation.observer.firstName + ' ' + observation.observer.lastName,
					'template'         : observation.template,
					'schoolName'       : observation.location.schoolName,
					'districtName'     : observation.location.districtName,
					'submitDate'       : observation.submitDate,
					'digitalSignature' : observation.digitalSignature || {}
				};

				if ( pd.dueDate ) {
					pdHolder.dueDate = moment( pdHolder.dueDate ).format( 'MM/DD/YY' );
				}

				if ( observation.type ) {
					pdHolder.observation.type = observation.type[ 0 ];
				}

				pdHolder.contentDescription = stripHTML( pdHolder.contentDescription );

				pdList.push( pdHolder );
			} );
		}

		function getFirstInstance ( item ) {
			return item.id === this.item.id;
		}

		function removeDuplicates ( item, index, collection ) {
			var data = item;

			if ( item.id ) {
				data = collection.filter( getFirstInstance.bind( {
					'item' : item
				} ) )[ 0 ];
			}

			return collection.indexOf( data ) === index;
		}

		function attachAttribute ( src, dest, attr ) {
			if ( src[ attr ] ) {
				dest[ attr ] = src[ attr ];
			}
		}

		function autoSelectWrap ( item ) {
			var resObj = {
				'name' : item.name || item
			};

			attachAttribute( item, resObj, 'id' );
			attachAttribute( item, resObj, 'filter' );
			attachAttribute( item, resObj, 'districtId' );
			attachAttribute( item, resObj, 'locationId' );

			return resObj;
		}

		function extractfilters ( collection, extractMap ) {
			return ( collection || [] )
				.map( extractMap )
				.filter( removeDuplicates )
				.sort()
				.map( autoSelectWrap );
		}

		function statusFilter () {
			return [ {
				'id'     : 1,
				'name'   : 'Complete',
				'filter' : function ( item ) {
					return item.completedDate;
				}
			}, {
				'id'     : 2,
				'name'   : 'Incomplete',
				'filter' : function ( item ) {
					return !item.completedDate;
				}
			} ];
		}

		function extractTemplates ( item ) {
			return {
				'name' : ( item.template || {} ).name,
				'id'   : ( item.template || {} ).id
			};
		}

		function extractInvitees ( item ) {
			return {
				'name'       : item.observee.firstName + ' ' + item.observee.lastName,
				'id'         : item.observee.id,
				'locationId' : item.location.observeeClientId
			};
		}

		function extractLocations ( item ) {
			return {
				'name'       : item.location.schoolName,
				'id'         : item.location.observeeClientId,
				'districtId' : item.location.districtId
			};
		}

		function extractDistricts ( item ) {
			return {
				'name' : item.location.districtName,
				'id'   : item.location.districtId
			};
		}

		function extractTypes ( item ) {
			if ( item.type ) {
				return item.type[ 0 ];
			}
		}

		function startsWith ( item ) {
			return item.name.toUpperCase().indexOf( this.query.toUpperCase() ) === 0;
		}

		function sortString ( prev, curr ) {
			return prev.name.localeCompare( curr.name );
		}

		function stringFilter ( query, collection ) {
			return ( collection || [] )
				.filter( startsWith.bind( {
					'query' : query
				} ) )
				.sort( sortString );
		}

		function wrap ( source, attrib, def ) {
			source[ attrib ] = source[ attrib ] || def;
			return source[ attrib ];
		}

		function push ( status, source, item ) {
			wrap( source, status, [] ).push( item );
		}

		function pushSource ( prev, item, source ) {
			var sigObj = angular.copy( item.observation.digitalSignature );

			item.icon = 'icon-record incomplete-pd';

			if ( item.completedDate || ( item.type === 4 && observationService.getValidSignature( sigObj.observer ) && observationService.getValidSignature( sigObj.observee ) ) ) {
				item.icon = 'icon-circle-check sinet-green';
				push( 'complete', source, item );
			}

			push( 'all', source, item );
			return prev;
		}

		function groupData ( prev, item ) {
			return pushSource( prev, item, wrap( wrap( prev, item.observation.schoolName, {} ), item.observation.observee, {} ) );
		}

		function insertData ( pd, key, info, all, done ) {
			pd.prev.push( {
				'school'   : pd.curr,
				'observee' : key,
				'status'   : done + ' of ' + all + ' (' + ( done / all * 100 ).toFixed( 1 ) + '%)',
				'data'     : info
			} );
		}

		function formRow ( pd, key, info ) {
			insertData( pd, key, info, info.all.length, ( info.complete || [] ).length );
		}

		function loopObservee ( key ) {
			formRow( this.pd, key, this.pd.currInfo[ key ] );
		}

		function processObservee ( prev, curr, currInfo ) {
			Object.keys( currInfo ).forEach( loopObservee.bind( {
				'pd' : {
					'prev'     : prev,
					'curr'     : curr,
					'currInfo' : currInfo
				}
			} ) );
			return prev;
		}

		function reduceObservee ( prev, curr ) {
			return processObservee( prev, curr, this.grouped[ curr ] );
		}

		function reduceGroup ( grouped ) {
			return Object.keys( grouped ).reduce( reduceObservee.bind( {
				'grouped' : grouped
			} ), [] );
		}

		function groupPds ( rawObsData ) {
			var rawData = angular.copy( rawObsData );

			return reduceGroup( rawData.reduce( groupData, {} ) );
		}

		function removeTypeDuplicates ( item, index, collection ) {
			return collection.indexOf( item ) === index && item !== undefined;
		}

		function convertToObject ( item ) {
			return { 'name' : item };
		}

		function typeFilter ( collection, extractMethod ) {
			return ( collection || [] )
				.map( extractMethod )
				.filter( removeTypeDuplicates )
				.sort()
				.map( convertToObject );
		}

		function getPdList () {
			return pdList;
		}

		function resetList () {
			pdList = [ ];
		}

		function filterData ( tags, filterArr, idKey ) {
			var list = [];

			filterArr.map( function ( filter ) {
				tags.map( function ( tag ) {
					if ( filter[ idKey ] === tag.id ) {
						list.push( filter );
					}
				} );
			} );

			return list;
		}

		return {
			'getPdList'      : getPdList,
			'resetList'      : resetList,
			'insertPdData'   : insertPdData,
			'extractfilters' : extractfilters,
			'statusFilter'   : statusFilter,
			'typeFilter'     : typeFilter,
			'groupPds'       : groupPds,
			'filters'        : {
				'stringFilter' : stringFilter,
				'filterData'   : filterData
			},

			'extractors' : {
				'templates' : extractTemplates,
				'invitees'  : extractInvitees,
				'locations' : extractLocations,
				'districts' : extractDistricts,
				'types'     : extractTypes
			}
		};
	}

	angular.module( 'app.report' )
		.factory( 'pdStatusFactory', pdStatusFactory );

	pdStatusFactory.$inject = [ 'moment', 'observationService' ];
} )( );
